import { enviarFormulario, obterHtml, obterJson } from './api';
import { avisarSucesso } from './aviso';
import { formatar, textos as lerTextos, url, urlApi } from './config';
import { desempilhar, empilhar } from './sobreposicao';
import { limparErros, mostrarErro, mostrarErros, validarAoVivo } from './campos';
import { comBotao, ocupado, ocupar } from './botao';

// Janela de criar e editar alerta (Views/PainelAlertaVaga/_JanelaV2.cshtml). A tela de alertas a traz no HTML; a busca, a
// profissão e a vaga pedem ao JanelaV2 na primeira vez.
const $ = id => document.getElementById(id);
// A mesma chave do conta-v2.js (_avisoDepoisDeRecarregar): o aviso de salvo aparece depois de a tela de alertas recarregar.
const _chaveAviso = 'v2-aviso-alerta';

let _dlg = null;
let _form = null;
let T = {};
let _pedido = null;
let _listaCidades = null;
// recarregar: a tela de alertas recarrega depois de salvar ou apagar; aoMudar({ novo, apagado }): as outras atualizam o botão.
// vez: cada abertura; a resposta de um envio de uma abertura anterior não mexe na janela de agora.
const _alerta = { id: 0, cargos: [], locais: [], gatilho: null, recarregar: false, aoMudar: null, vez: 0 };

// O cargo escrito e não adicionado também conta: o erro é o mesmo no envio e ao sair do campo.
function _regraCargo() {
    const cargo = $('cxAlCargo').value.trim();
    if (!cargo) {
        return _alerta.cargos.length ? '' : T.erroCargo;
    }
    return _alerta.cargos.length >= 5 && !_alerta.cargos.some(c => c.toLowerCase() === cargo.toLowerCase()) ? T.erroCincoCargos : '';
}

function _chips() {
    const desenhar = (tipo, itens, rotulo) => {
        _form.querySelector(`[data-al-chips="${tipo}"]`).replaceChildren(...itens.map((item, i) => {
            const li = document.createElement('li');
            const nome = document.createElement('span');
            nome.textContent = rotulo(item);
            const tirar = document.createElement('button');
            tirar.type = 'button';
            tirar.dataset.alTirar = `${tipo}:${i}`;
            tirar.setAttribute('aria-label', formatar(T.remover, rotulo(item)));
            tirar.innerHTML = '<svg class="ico" aria-hidden="true"><use href="#i-x-lg"></use></svg>';
            li.append(nome, tirar);
            return li;
        }));
    };
    desenhar('cargos', _alerta.cargos, c => c);
    desenhar('locais', _alerta.locais, l => l.t);
    // O atalho some quando o lugar já está no alerta.
    _form.querySelectorAll('[data-al-local]').forEach(b => {
        b.hidden = _alerta.locais.some(l => l.v.toLowerCase() === b.dataset.alLocal.toLowerCase());
    });
}

// O resto (histórico, lista de cidades, foco) fica no "close" da janela, que todo jeito de fechar dispara.
function _fechar() {
    if (_dlg?.open) {
        _dlg.close();
    }
}

function _addCargo() {
    const campo = $('cxAlCargo');
    const cargo = campo.value.trim().slice(0, 150);
    if (!cargo) {
        return true;
    }
    if (!_alerta.cargos.some(c => c.toLowerCase() === cargo.toLowerCase())) {
        if (_alerta.cargos.length >= 5) {
            mostrarErro(campo, T.erroCincoCargos);
            return false;
        }
        _alerta.cargos.push(cargo);
    }
    campo.value = '';
    mostrarErro(campo, '');
    _chips();
    return true;
}

function _addLocal(v, t) {
    if (_alerta.locais.some(l => l.v.toLowerCase() === v.toLowerCase())) {
        return;
    }
    if (_alerta.locais.length >= 5) {
        mostrarErro($('cxAlCidade'), T.erroCincoCidades);
        return;
    }
    _alerta.locais.push({ v, t });
    mostrarErro($('cxAlCidade'), '');
    _chips();
}

// Lista de cidades (api variaveis/cidades/buscarV2, a mesma do modal de hoje) presa ao campo, como a do cadastro v2.
function _ligarListaCidades() {
    const campo = $('cxAlCidade');
    const lista = $('cxAlCidadeLista');
    let espera = null;
    let controle = null;
    let itens = [];
    let ativo = -1;
    const fechar = () => {
        lista.hidden = true;
        campo.setAttribute('aria-expanded', 'false');
        campo.removeAttribute('aria-activedescendant');
        ativo = -1;
    };
    const escolher = i => {
        const c = itens[i];
        if (c) {
            _addLocal(c.nome, c.nome.replace(/, BR$/, ''));
            campo.value = '';
            fechar();
        }
    };
    const desenhar = () => {
        const opcoes = itens.map((c, i) => {
            const li = document.createElement('li');
            li.id = `${lista.id}-${i}`;
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.className = 'cx-alf__opc';
            li.dataset.i = i;
            li.textContent = c.nome.replace(/, BR$/, '');
            return li;
        });
        if (!opcoes.length) {
            const vazio = document.createElement('li');
            vazio.className = 'cx-alf__vazio';
            vazio.setAttribute('role', 'option');
            vazio.setAttribute('aria-disabled', 'true');
            vazio.textContent = T.cidadeNenhuma;
            opcoes.push(vazio);
        }
        lista.replaceChildren(...opcoes);
        lista.hidden = false;
        campo.setAttribute('aria-expanded', 'true');
    };
    campo.addEventListener('input', () => {
        clearTimeout(espera);
        const termo = campo.value.trim();
        if (termo.length < 2) {
            fechar();
            return;
        }
        espera = setTimeout(async () => {
            controle?.abort();
            controle = new AbortController();
            try {
                const r = await obterJson(urlApi(`/variaveis/cidades/buscarV2?query=${encodeURIComponent(termo)}`), { sinal: controle.signal });
                const dados = r?.dados ?? r?.Dados;
                // Só cidade de verdade ("Cidade, UF, País"): o índice também tem "Brasil, BR".
                itens = (Array.isArray(dados) ? dados : []).map(c => ({ nome: c.nome ?? c.Nome ?? '' })).filter(c => c.nome.split(',').length >= 3).slice(0, 8);
                desenhar();
            } catch (erro) {
                if (erro.name !== 'AbortError') {
                    fechar();
                }
            }
        }, 250);
    });
    lista.addEventListener('mousedown', e => {
        const li = e.target.closest('[data-i]');
        if (li) {
            e.preventDefault();
            escolher(+li.dataset.i);
        }
    });
    campo.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            // Enter no campo não envia o formulário: escolhe a cidade marcada (ou nada).
            e.preventDefault();
            if (!lista.hidden && ativo >= 0) {
                escolher(ativo);
            }
            return;
        }
        // Esc com a lista aberta (mesmo a de "nenhuma cidade") fecha só a lista, não o formulário nem a janela
        // (o preventDefault segura o Esc nativo do <dialog>).
        if (e.key === 'Escape' && !lista.hidden) {
            e.preventDefault();
            e.stopPropagation();
            fechar();
            return;
        }
        if (lista.hidden || !itens.length) {
            return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            ativo = (ativo + (e.key === 'ArrowDown' ? 1 : -1) + itens.length) % itens.length;
            [...lista.children].forEach((li, i) => li.setAttribute('aria-selected', String(i === ativo)));
            campo.setAttribute('aria-activedescendant', `${lista.id}-${ativo}`);
            lista.children[ativo]?.scrollIntoView({ block: 'nearest' });
        }
    });
    campo.addEventListener('blur', () => setTimeout(fechar, 150));
    return { fechar };
}

function _abrirApagar(abrir) {
    const botao = _form.querySelector('[data-al-apagar]');
    $('cxAlApagar').hidden = !abrir;
    botao.hidden = abrir;
    botao.setAttribute('aria-expanded', String(abrir));
    if (abrir) {
        _form.querySelector('[data-al-apagar-nao]').focus();
    }
}

// Saindo com a janela aberta: a entrada dela sai do histórico antes de recarregar, senão o Voltar depois pede dois toques.
function _recarregar() {
    const ir = () => window.location.reload();
    if (_dlg.open && history.state?.v2Alerta) {
        window.addEventListener('popstate', ir, { once: true });
        history.back();
    } else {
        ir();
    }
}

async function _enviar(endereco, dados, botao, erroPadrao, avisoOk) {
    const { vez, aoMudar, id } = _alerta;
    // A resposta que recarrega a página (sessão vencida, ou salvo na tela de alertas) deixa o botão com a roda até lá; a de antes
    // de a janela ser reaberta não mexe nele (a reabertura já o soltou, e ele pode estar num envio novo).
    const recarrega = r => vez !== _alerta.vez || r?.erroAutenticacao || (r?.sucesso && _alerta.recarregar);
    const resposta = await comBotao(botao, () => enviarFormulario(url(endereco), dados).catch(() => null), { manter: recarrega });
    if (resposta === undefined) {
        return;
    }
    // A janela foi fechada e aberta de novo durante o envio: a resposta não mexe nela, mas a página ainda se atualiza.
    if (vez !== _alerta.vez) {
        if (resposta?.sucesso) {
            aoMudar?.({ novo: !id && !endereco.endsWith('/Excluir'), apagado: endereco.endsWith('/Excluir') });
        }
        return;
    }
    // Sessão vencida: recarregar leva ao login e volta para cá.
    if (resposta?.erroAutenticacao || (resposta?.sucesso && _alerta.recarregar)) {
        if (resposta.sucesso) {
            try {
                sessionStorage.setItem(_chaveAviso, avisoOk);
            } catch {
                // Sem armazenamento, sem o aviso.
            }
        }
        _recarregar();
        return;
    }
    if (resposta?.sucesso) {
        _fechar();
        avisarSucesso(avisoOk);
        const apagado = endereco.endsWith('/Excluir');
        aoMudar?.({ novo: !id && !apagado, apagado });
        return;
    }
    mostrarErro(null, resposta?.mensagem || erroPadrao, $('cxAlErro'));
}

function _salvar() {
    mostrarErro(null, '', $('cxAlErro'));
    mostrarErro($('cxAlCidade'), '');
    if (mostrarErros([[$('cxAlCargo'), _regraCargo()]])) {
        return;
    }
    // O cargo escrito e não adicionado entra antes de enviar.
    _addCargo();
    const dados = new FormData();
    dados.append('ID', String(_alerta.id));
    _alerta.cargos.forEach(c => dados.append('Cargos', c));
    _alerta.locais.forEach(l => dados.append('Localidades', l.v));
    dados.append('Frequencia', _form.querySelector('[name=Frequencia]:checked')?.value || '1');
    _enviar('/PainelAlertaVaga/Salvar', dados, _form.querySelector('[type=submit]'), T.erroSalvar, T.avisoSalvo);
}

function _ligar() {
    _listaCidades = _ligarListaCidades();
    _form.addEventListener('click', e => {
        const tirar = e.target.closest('[data-al-tirar]');
        if (tirar) {
            const [tipo, i] = tirar.dataset.alTirar.split(':');
            _alerta[tipo].splice(+i, 1);
            const campo = $(tipo === 'cargos' ? 'cxAlCargo' : 'cxAlCidade');
            mostrarErro(campo, '');
            _chips();
            campo.focus();
            return;
        }
        if (e.target.closest('[data-al-add-cargo]')) {
            _addCargo();
            $('cxAlCargo').focus();
            return;
        }
        const local = e.target.closest('[data-al-local]');
        if (local) {
            _addLocal(local.dataset.alLocal, local.dataset.alRotulo);
            $('cxAlCidade').focus();
            return;
        }
        if (e.target.closest('[data-al-cancelar]')) {
            _fechar();
            return;
        }
        if (e.target.closest('[data-al-apagar]')) {
            _abrirApagar(true);
            return;
        }
        if (e.target.closest('[data-al-apagar-nao]')) {
            _abrirApagar(false);
            _form.querySelector('[data-al-apagar]').focus();
            return;
        }
        const sim = e.target.closest('[data-al-apagar-sim]');
        if (sim) {
            const dados = new FormData();
            dados.append('id', String(_alerta.id));
            _enviar('/PainelAlertaVaga/Excluir', dados, sim, T.erroApagar, T.avisoApagado);
        }
    });
    $('cxAlCargo').addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            _addCargo();
        }
    });
    _form.addEventListener('submit', e => {
        e.preventDefault();
        _salvar();
    });
    _form.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            // Só a janela: o Esc não chega ao painel da vaga que está por baixo.
            e.preventDefault();
            e.stopPropagation();
            _fechar();
        }
    });
    // Fecha pelo fundo só quando o toque começou nele: selecionar o texto de um campo e soltar fora não fecha.
    // O segundo clique de um duplo clique no "Editar" cai no fundo e também não fecha.
    let toqueNoFundo = false;
    _dlg.addEventListener('pointerdown', e => { toqueNoFundo = e.target === _dlg; });
    _dlg.addEventListener('click', e => {
        if (e.target === _dlg && toqueNoFundo && e.detail < 2) {
            _fechar();
        }
    });
    _dlg.addEventListener('close', () => {
        desempilhar('v2Alerta');
        _listaCidades.fechar();
        if (_alerta.gatilho?.isConnected) {
            _alerta.gatilho.focus();
        }
    });
    validarAoVivo(_form, { cxAlCargo: _regraCargo });
}

async function _janela() {
    if (_dlg) {
        return;
    }
    let dlg = $('cxAlDlg');
    if (!dlg) {
        _pedido ??= obterHtml(url('/PainelAlertaVaga/JanelaV2'), { semCache: true })
            .then(html => {
                const modelo = document.createElement('template');
                modelo.innerHTML = html;
                const nova = modelo.content.querySelector('#cxAlDlg');
                if (!nova) {
                    throw new Error('janela do alerta');
                }
                document.body.append(nova);
                return nova;
            })
            .finally(() => { _pedido = null; });
        dlg = await _pedido;
    }
    if (_dlg) {
        return;
    }
    _dlg = dlg;
    _form = $('cxAlForm');
    T = lerTextos(_dlg);
    _ligar();
}

// dados: { id, cargos, locais: [{ v, t }], semanal } (sem id, um alerta novo já preenchido).
export async function abrirJanelaAlerta(dados, { gatilho = null, recarregar = false, aoMudar = null } = {}) {
    // Na 1ª vez a janela vem do servidor: a roda no botão que abriu (se quem chamou já não a pôs).
    const proprio = gatilho && !ocupado(gatilho);
    if (proprio) {
        ocupar(gatilho);
    }
    try {
        await _janela();
    } finally {
        if (proprio) {
            ocupar(gatilho, false);
        }
    }
    _alerta.id = dados?.id || 0;
    _alerta.cargos = [...(dados?.cargos || [])];
    _alerta.locais = (dados?.locais || []).map(l => ({ ...l }));
    _alerta.gatilho = gatilho;
    _alerta.recarregar = recarregar;
    _alerta.aoMudar = aoMudar;
    _alerta.vez++;
    _form.reset();
    _form.querySelectorAll('[aria-busy]').forEach(b => ocupar(b, false));
    _form.querySelector(`[name=Frequencia][value="${dados?.semanal ? 2 : 1}"]`).checked = true;
    $('cxAlFormT').textContent = _alerta.id ? T.editar : T.novo;
    _form.querySelector('[data-al-apagar-bloco]').hidden = !_alerta.id;
    _abrirApagar(false);
    limparErros(_form);
    _chips();
    _dlg.showModal();
    // O Voltar do Android fecha a janela em vez de sair da página.
    empilhar('v2Alerta', () => _dlg.close());
    $('cxAlFormT').focus({ preventScroll: true });
}

// O alerta de uma busca (cargo e cidade, como o índice compara) no AlertaDaBuscaV2: um cargo só cabe em um alerta da conta
// (AlertaVagaBusiness._validacaoAlertasExistentes), então o que já tem o cargo abre para editar, com a cidade da busca somada
// quando ele não a cobre; sem ele, um alerta novo já preenchido.
export async function obterAlertaDaBusca(cargo, local = '') {
    const r = await obterJson(url(`/Vagas/AlertaDaBuscaV2?cargo=${encodeURIComponent(cargo)}&local=${encodeURIComponent(local)}`), { semCache: true });
    if (!r?.sucesso) {
        throw new Error('alerta da busca');
    }
    return r;
}

// Falso quando a sessão não é de candidato (venceu, por exemplo): quem chamou leva ao login.
export async function abrirAlertaDaBusca(cargo, local, opcoes) {
    const r = await obterAlertaDaBusca(cargo, local);
    if (r.logado === false) {
        return false;
    }
    const a = r.alerta;
    const locais = a ? a.locais.map((v, i) => ({ v, t: a.rotulos[i] || v })) : [];
    if (r.local && !r.cobre && locais.length < 5 && !locais.some(l => l.v.toLowerCase() === r.local.v.toLowerCase())) {
        locais.push(r.local);
    }
    await abrirJanelaAlerta(a ? { id: a.id, cargos: a.cargos, locais, semanal: a.semanal } : { cargos: [cargo], locais }, opcoes);
    return true;
}

// ?alerta=1 (a volta do login, o "Avise-me" do autocomplete): pede a janela ao abrir a página e sai da URL (o F5 não abre de novo).
export function alertaPedidoNaUrl() {
    const q = new URLSearchParams(window.location.search);
    if (q.get('alerta') !== '1') {
        return false;
    }
    q.delete('alerta');
    const resto = q.toString();
    history.replaceState(history.state, '', `${window.location.pathname}${resto ? `?${resto}` : ''}${window.location.hash}`);
    return true;
}
